module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricelistsList"
  }, [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('center', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.loaded == false) ? _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [(_vm.loaded == true) ? _c('div', {
    staticClass: "relative"
  }, [(_vm.search != '') ? _c('a', {
    staticClass: "searchTypeClear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearSearch.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons searchTypeClearText"
  }, [_vm._v("close")])]) : _vm._e(), _vm._v(" "), (_vm.search != '') ? _c('v-text-field', {
    attrs: {
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.search == '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [(_vm.loaded == true && _vm.hasDefaultError == true) ? _c('p', {
    staticClass: "plistDefaultError"
  }, [_vm._v("No default pricelist is set."), _c('br'), _vm._v("Only pricelists assigned specifically to the user or the user role will be used.")]) : _vm._e()])], 1), _vm._v(" "), (_vm.loaded == true) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.pricelistList,
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s(props.item.pl_name))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.pl_description))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_vm._v(_vm._s(_vm.fncCheckStatus(props.item.pl_active)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_vm._v(_vm._s(props.item.pl_revision))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_vm._v(_vm._s(_vm.fncCheckStatus(props.item.pl_is_default)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_vm._v(_vm._s(_vm.fncCheckStatus(props.item.pl_is_cost)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.pl_modified))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRICELISTS') !== -1) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncClonePricelist(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("compare_arrows")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRICELISTS') !== -1) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditPricelist(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e()]
      }
    }], null, false, 1697629919)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}